import { render, staticRenderFns } from "./ProfileRegister.html?vue&type=template&id=5dacb5ab&scoped=true&"
import script from "./ProfileRegister.vue?vue&type=script&lang=js&"
export * from "./ProfileRegister.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRegister.scss?vue&type=style&index=0&id=5dacb5ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dacb5ab",
  null
  
)

export default component.exports